import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthService {

    constructor(
        private _cookieService: CookieService,
        private _router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('userName') && localStorage.getItem('userRole')) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this._router.navigate(['/signin']);
        return false;
    }

    public setAuthToken(token): void {
        this._cookieService.set('x-header-authtoken', token, this.getCookieExpiry());
    }

    public setRefreshToken(token): void {
        this._cookieService.set('x-header-refreshtoken', token, this.getCookieExpiry());
    }

    public getAuthToken(): string {
        return this._cookieService.get('x-header-authtoken');
    }
    public getRefreshToken(): string {
        return this._cookieService.get('x-header-refreshtoken');
    }

    public getCookieExpiry(): number {
        return 2;   // days
    }

    public infiniteCookieExpiry(): Date {
        let expireDate = new Date();
        expireDate.setTime(2144232732000); // To date 30th Dec 2037 - 2037-12-12T12:12:12.000Z
        return expireDate;
    }

    public clearAllCookies() {
        this._cookieService.deleteAll();
    }
}





// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts